import { render, staticRenderFns } from "./RealtimeCallsinQueue.vue?vue&type=template&id=5d4d1514&scoped=true"
import script from "./RealtimeCallsinQueue.vue?vue&type=script&lang=js"
export * from "./RealtimeCallsinQueue.vue?vue&type=script&lang=js"
import style0 from "./RealtimeCallsinQueue.vue?vue&type=style&index=0&id=5d4d1514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4d1514",
  null
  
)

export default component.exports